// extracted by mini-css-extract-plugin
export default {"app":"src-components-App-module__app--K8yfK","content":"src-components-App-module__content--XyVF6","mainContent":"src-components-App-module__mainContent--X0dXu"};